import { create } from "zustand";
import { persist, createJSONStorage } from 'zustand/middleware'
import { createAppSlice, AppSlice } from "./app-slice.ts";
import { createPropertySlice, PropertySlice } from "./property-slice.ts";
import { ApiSlice, createApiSlice } from "./api-slice.ts";

export const useStore = create<AppSlice & ApiSlice & PropertySlice>()(
  persist(
    (...a) => ({
    ...createAppSlice(...a),
    ...createApiSlice(...a),
    ...createPropertySlice(...a),
    }),
    {
      name: 'esr-state-storage-'+window.location.host.replace(/[\./]/g,''),
      version: Date.now(),
      migrate: (persistedState, version) => {
        if (Date.now() - version > 0) { //86400000
          return {};
          //return {...persistedState as object}
        }
        return persistedState
      },
      onRehydrateStorage: (_state) => {
        return (_state, _error) => {
          async function init_request(){
            //console.log("loading state");
          }
          init_request();
        }
      },  
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => 
            !['config', 'translation'].includes(key)
        )),
      storage: createJSONStorage(() => localStorage),
    }
  ));